var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRescheduleHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9076 14.2031H42.7071V17.5607C42.7071 19.1817 41.3923 20.5047 39.763 20.5047H37.2409C35.6199 20.5047 34.2969 19.19 34.2969 17.5607V14.2031H21.7027V17.5607C21.7027 19.1817 20.388 20.5047 18.7587 20.5047H16.2366C14.6156 20.5047 13.2925 19.19 13.2925 17.5607V14.2031H9.10028C7.94278 14.2031 7 15.1459 7 16.3034V49.9094C7 51.0669 7.94278 52.0097 9.10028 52.0097H46.9069C48.0644 52.0097 49.0071 51.0669 49.0071 49.9094V16.3042C49.0071 15.1467 48.0644 14.2039 46.9069 14.2039L46.9076 14.2031ZM44.8073 46.9654C44.8073 47.4281 44.4354 47.8091 43.9636 47.8091H12.0443C11.5816 47.8091 11.2006 47.4372 11.2006 46.9654V27.6486C11.2006 27.1859 11.5725 26.8048 12.0443 26.8048H43.9636C44.4263 26.8048 44.8073 27.1768 44.8073 27.6486V46.9654Z",
    fill: "#2E406F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2441 18.4011H39.7663C40.229 18.4011 40.61 18.0292 40.61 17.5574V10.8437C40.61 10.381 40.2381 10 39.7663 10H37.2441C36.7814 10 36.4004 10.372 36.4004 10.8437V17.5665C36.4004 18.0216 36.7724 18.4019 37.2441 18.4019V18.4011Z",
    fill: "#2E406F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2402 18.4011H18.7624C19.2251 18.4011 19.6061 18.0292 19.6061 17.5574V10.8437C19.6061 10.381 19.2341 10 18.7624 10H16.2402C15.7775 10 15.3965 10.372 15.3965 10.8437V17.5665C15.3965 18.0216 15.7768 18.4019 16.2402 18.4019V18.4011Z",
    fill: "#2E406F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8678 31H18.3457C17.883 31 17.502 31.372 17.502 31.8437V34.3659C17.502 34.8286 17.8739 35.2096 18.3457 35.2096H20.8678C21.3305 35.2096 21.7116 34.8377 21.7116 34.3659V31.8437C21.7116 31.381 21.3396 31 20.8678 31Z",
    fill: "#2E406F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6589 31H35.1367C34.674 31 34.293 31.372 34.293 31.8437V34.3659C34.293 34.8286 34.6649 35.2096 35.1367 35.2096H37.6589C38.1216 35.2096 38.5026 34.8377 38.5026 34.3659V31.8437C38.5026 31.381 38.1223 31 37.6589 31Z",
    fill: "#2E406F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8678 39.4062H18.3457C17.883 39.4062 17.502 39.7782 17.502 40.25V42.7721C17.502 43.2348 17.8739 43.6159 18.3457 43.6159H20.8678C21.3305 43.6159 21.7116 43.2439 21.7116 42.7721V40.25C21.7116 39.779 21.3396 39.4062 20.8678 39.4062Z",
    fill: "#2E406F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2643 39.4062H26.7422C26.2795 39.4062 25.8984 39.7782 25.8984 40.25V42.7721C25.8984 43.2348 26.2704 43.6159 26.7422 43.6159H29.2643C29.727 43.6159 30.1081 43.2439 30.1081 42.7721V40.25C30.1081 39.779 29.7278 39.4062 29.2643 39.4062Z",
    fill: "#2E406F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L54 58",
    stroke: "#0F1E45",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9L50 57",
    stroke: "#2E406F",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRescheduleHistory);
export default __webpack_public_path__ + "static/media/NoRescheduleHistory.24592ebe543657c1da2b650a528f11f7.svg";
export { ForwardRef as ReactComponent };